'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _search = require('./search');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.search', []);

_module.config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    $stateProvider.state('search', {
        parent: 'general',
        url: '/search/:searchValue?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'search'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: '24',
                squash: true
            },
            sortProperty: {
                value: sortProperties['Name'].value,
                squash: true
            },
            sortAsc: {
                value: (sortProperties['Name'].defaultSorting === 'asc').toString(),
                squash: true
            },
            filter: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Search" | translate}}'
        }
    });
}]);

_module.component('search', _search.searchComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/search/index.js
// module id = 1006
// module chunks = 0